import {
  Email2czi041hozwks as Email,
  TimeBasedOTP29tckvyi0qgqr as TimeBasedOTP,
  Password1ydqms6ppq4qq as Password,
  BackupCode3usy9yc0uco6j as BackupCode,
} from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/proofs/LiveProofClientEndpoints.mjs';
import {
  Email1w7ox5oeijz9q as Email_0,
  TimeBasedOTP8rvmui1ob933 as TimeBasedOTP_0,
  Password2oz6lme4sxm35 as Password_0,
} from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/proofs/ProofClientEndpoints.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance2xu56kdtu70pg as Companion_getInstance,
  TotpSecret2n8wncod0kzme as TotpSecret,
  Companion_instanced3br7ruy9wqq as Companion_instance,
  PasswordSecret1fpysq9jnp6wb as PasswordSecret,
} from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/AuthSecrets.mjs';
import {
  Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance_0,
  Uuid1zxgztb7abqxx as Uuid,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  serializer1x80idigipeic as serializer,
  serializer1cdzkc3mnhoc4 as serializer_0,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  serializer1x79l67jvwntn as serializer_1,
  serializer3u3hsxnenk49x as serializer_2,
  MapSerializer11kmegt3g5c1g as MapSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  LiveClientModelRestEndpoints1iiraf6ocg5qo as LiveClientModelRestEndpoints,
  LiveClientModelRestEndpointsAndUpdatesWebSocket2xmxa2mxjm57q as LiveClientModelRestEndpointsAndUpdatesWebSocket,
} from '../../../../../lightning-server-typed-shared/com/lightningkite/lightningserver/typed/LiveClientModelRestEndpoints.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstance1y5mh6uowmcdd as Companion_getInstance_1,
  Companion_getInstance4qyyemyqnult as Companion_getInstance_2,
  NotificationSendMethods1rnwccbrbx64q as NotificationSendMethods,
} from '../../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/subscriptions/subscriptionModels.mjs';
import {
  Companion_instancef6fjaxfv49x1 as Companion_instance_0,
  Companion_getInstance2r6pafkc2qafn as Companion_getInstance_3,
  Companion_instancen4rpxo41w4o4 as Companion_instance_1,
  Companion_instance2wd0q10x4wldy as Companion_instance_2,
  ID1eab8795lyj01 as ID,
  FcmTokenzn8ju01ll1ql as FcmToken,
  Companion_getInstance1ljiqntaxe0m9 as Companion_getInstance_4,
  Companion_instancexzjj08lu6v7y as Companion_instance_3,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import {
  Companion_getInstance2j1uv91l5kue6 as Companion_getInstance_5,
  UserEventType9fgr3eoymf06 as UserEventType,
} from '../../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/events/eventModels.mjs';
import { Companion_getInstancel4ymxmn2l08f as Companion_getInstance_6 } from '../../../../../lightning-server-core-shared/com/lightningkite/lightningserver/HttpMethod.mjs';
import { ClientModelRestUpdatesWebSocket3jbuy8au3ubru as ClientModelRestUpdatesWebSocket } from '../../../../../lightning-server-typed-shared/com/lightningkite/lightningserver/typed/ClientModelRestEndpoints.mjs';
import {
  Companion_instance1tjb9nvha71oi as Companion_instance_4,
  DynamicSettingsasnz4qmzwqci as DynamicSettings,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/dynamicSettings.mjs';
import {
  StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance,
  BooleanCompanionObject_instance2tls5h1cufcrh as BooleanCompanionObject_instance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  Companion_getInstance2v1f7yxfwu10q as Companion_getInstance_7,
  Session1fsuafg4xfsqb as Session,
} from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/sessionModels.mjs';
import { LiveAuthClientEndpoints3n10lw5s4xv4t as LiveAuthClientEndpoints } from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/proofs/LiveAuthClientEndpoints.mjs';
import { Companion_getInstance2k7q2bnzfxhnl as Companion_getInstance_8 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/EntryChange.mjs';
import {
  Companion_getInstanceddq4orui8c5e as Companion_getInstance_9,
  Notification1y91jemwm75tr as Notification,
} from '../../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/notificationModels.mjs';
import { Companion_instance9ofeumbwb97p as Companion_instance_5 } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/notifications.mjs';
import {
  Companion_getInstancevgnjncsigc6q as Companion_getInstance_10,
  Companion_instance2sj66pqhk0s5j as Companion_instance_6,
  Companion_instance1m8froy0l9g5n as Companion_instance_7,
  Companion_instance3qgdrppmt617n as Companion_instance_8,
  FamilyApplication2f6semoy1a9hz as FamilyApplication,
  ID3eto015dm4eyk as ID_0,
  Companion_getInstance2yczpxlc95n6h as Companion_getInstance_11,
  Companion_instances36b4kf4ntme as Companion_instance_9,
  Companion_instance2e7hhq61fk0bx as Companion_instance_10,
  Companion_instance18ghsn8rlu2k9 as Companion_instance_11,
  ProviderApplicationj6elx51glw3 as ProviderApplication,
  ID3deomyff8nvpw as ID_1,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/applications.mjs';
import {
  Companion_getInstance3n8qsn7k1orly as Companion_getInstance_12,
  Companion_instance2y15a46qisr4b as Companion_instance_12,
  ChildPlacement1fdgqwhgo48yv as ChildPlacement,
  IDknm0szoty74n as ID_2,
  Companion_getInstance29yv2m82qhueb as Companion_getInstance_13,
  Companion_instance8lbogr8agtsk as Companion_instance_13,
  ChildAttendance80k6ssgtlom9 as ChildAttendance,
  ID3dyn3t5exl4nz as ID_3,
  Companion_getInstance5c3fz7snx10k as Companion_getInstance_14,
  Companion_instance1mnwh6xdpvhnr as Companion_instance_14,
  CareLocationClosure1da03s5ze3kft as CareLocationClosure,
  ID2snwv1w0j940u as ID_4,
  Companion_instance31zndpf9pf1oi as Companion_instance_15,
  Companion_instance10xobi09i40c6 as Companion_instance_16,
  LocationAttendancePeriod3bx3r7kkwecs9 as LocationAttendancePeriod,
  ID14pksykyak8vt as ID_5,
  Companion_getInstance3624xnlg0493t as Companion_getInstance_15,
  Companion_instancelcp2fs9k43iy as Companion_instance_17,
  CareLocation1v3u5wduz023s as CareLocation,
  ID1z61wlmtvxrjn as ID_6,
  IDqqik72jjbpsn as ID_7,
  Companion_instance1cosffgar2men as Companion_instance_18,
  Companion_getInstance2jaanzr07h9qp as Companion_getInstance_16,
  Companion_instance3zv09yetnwap as Companion_instance_19,
  Companion_instanceh1a9dxwm5f9z as Companion_instance_20,
  Companion_instance1ml9kof67ycp as Companion_instance_21,
  Companion_getInstance8cw09c4jvk3w as Companion_getInstance_17,
  Companion_instance11icbntvxyz47 as Companion_instance_22,
  Companion_instance3i4ej7wheox62 as Companion_instance_23,
  Companion_instanceijzyzhvr52hy as Companion_instance_24,
  Companion_instance2mni8afnohjti as Companion_instance_25,
  Companion_instanceu8ez89pi8m0d as Companion_instance_26,
  Companion_instance2s5c8hzy4nzse as Companion_instance_27,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import {
  Companion_getInstance3rx4dbijulyuv as Companion_getInstance_18,
  Companion_instance1tbwufhoxgh91 as Companion_instance_28,
  CareLocationProgrameuu05ugy00sb as CareLocationProgram,
  ID3lnbkn76l7dgd as ID_8,
  Companion_instancesqd80ja9ulcs as Companion_instance_29,
  Companion_instance31cl4jss4rew2 as Companion_instance_30,
  CareLocationProgramDated2hjmsy0f9azw0 as CareLocationProgramDated,
  ID1lpgwt2us7em9 as ID_9,
  Companion_getInstanceyrbofvk90ue2 as Companion_getInstance_19,
  Companion_instance1yqwk60hvo8wt as Companion_instance_31,
  Companion_instance2km53rz6tjv2o as Companion_instance_32,
  Companion_instance6mmlcn2whvbb as Companion_instance_33,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import {
  Companion_getInstance1ytzay7iyj05v as Companion_getInstance_20,
  Companion_instance228e8j20cxdzg as Companion_instance_34,
  Companion_instance3fp35l9mm3c9t as Companion_instance_35,
  Companion_getInstance3sc92273t9rvh as Companion_getInstance_21,
  CareProviderRemittances9omflxtwvni as CareProviderRemittance,
  ID1sgzzdpfpwkrm as ID_10,
  Companion_getInstance2ufvbwwa42es2 as Companion_getInstance_22,
  Companion_instance10dn71lg9ig3t as Companion_instance_36,
  Companion_getInstance2uuaiykt2g0g3 as Companion_getInstance_23,
  SingleChildDayfsi906tc8dp6 as SingleChildDay,
  ID2pi5mto15i7f6 as ID_11,
  Companion_instance1d8b451omsiul as Companion_instance_37,
  Companion_instance3px40qt4y9hbg as Companion_instance_38,
  Companion_instance3rsay32qgy1xl as Companion_instance_39,
  Companion_instance2ukmb1iai6ee6 as Companion_instance_40,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import { Companion_instance170wh3hu8c61 as Companion_instance_41 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import {
  ID3b6wrkk3fpdmq as ID_12,
  Companion_instance2hpuio2jmf9d2 as Companion_instance_42,
  Companion_instance3h9d5wsjmuw70 as Companion_instance_43,
  Companion_getInstance3b4ushpbkvgrv as Companion_getInstance_24,
  Companion_getInstance29sht6afyr9n6 as Companion_getInstance_25,
  Companion_getInstance3d75st4ngxjes as Companion_getInstance_26,
  Companion_getInstancecv02zznkeg7m as Companion_getInstance_27,
  Companion_getInstance39bhohmo3c08b as Companion_getInstance_28,
  Companion_getInstance67t3dbcjzlfh as Companion_getInstance_29,
  Companion_instancebdn3v0qctmd1 as Companion_instance_44,
  Companion_instance36og04a4bn8yo as Companion_instance_45,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/survey.mjs';
import { LiveClientUploadEarlyEndpoints3jopcpgrbec1u as LiveClientUploadEarlyEndpoints } from '../../../../../lightning-server-files-shared/com/lightningkite/lightningserver/files/LiveClientModelRestEndpoints.mjs';
import {
  Companion_getInstance3a5neho85mvmw as Companion_getInstance_30,
  Companion_instance3tku9brqye44b as Companion_instance_46,
  Companion_getInstance1z0h5xsn2wljo as Companion_getInstance_31,
  Companion_instance2a6uspwvcbi9a as Companion_instance_47,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/subsidyRates.mjs';
import {
  Companion_getInstance1ymz2mf6vmsl4 as Companion_getInstance_32,
  Companion_instancenb4qjspelti9 as Companion_instance_48,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/employerAggregations.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LiveEmailApiClass;
function LiveEmailApi() {
  if (LiveEmailApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (Email())(this.$this_1.$this_1.fetcher_1, 'auth/proof/email');
      }
      *beginEmailOwnershipProof_z98tf3_k$(input, $completion) {
        return yield* this.$$delegate_0__1.beginEmailOwnershipProof_z98tf3_k$(input, $completion);
      }
      *proveEmailOwnership_zd3jgf_k$(input, $completion) {
        return yield* this.$$delegate_0__1.proveEmailOwnership_zd3jgf_k$(input, $completion);
      }
      get_via_18itzv_k$() {
        return this.$$delegate_0__1.get_via_18itzv_k$();
      }
      get_property_msvula_k$() {
        return this.$$delegate_0__1.get_property_msvula_k$();
      }
    }
    initMetadataForClass($, 'LiveEmailApi', VOID, VOID, [Email_0()], [1]);
    LiveEmailApiClass = $;
  }
  return LiveEmailApiClass;
}
var LiveTimeBasedOTPProofClass;
function LiveTimeBasedOTPProof() {
  if (LiveTimeBasedOTPProofClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (TimeBasedOTP())(this.$this_1.$this_1.fetcher_1, 'auth/proof/totp');
        this.$$delegate_1__1 = new (LiveClientModelRestEndpoints())(this.$this_1.$this_1.fetcher_1, 'auth/proof/totp/secrets', Companion_getInstance().serializer_9w0wvi_k$(), serializer(Companion_getInstance_0()));
      }
      *proveOTP_hnj5ta_k$(input, $completion) {
        return yield* this.$$delegate_0__1.proveOTP_hnj5ta_k$(input, $completion);
      }
      get_via_18itzv_k$() {
        return this.$$delegate_0__1.get_via_18itzv_k$();
      }
      get_property_msvula_k$() {
        return this.$$delegate_0__1.get_property_msvula_k$();
      }
      *query_vbch90_k$(input, $completion) {
        return yield* this.$$delegate_1__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_vbch90_k$(input, $completion);
      }
      *insertBulk_q5ivxg_k$(input, $completion) {
        return yield* this.$$delegate_1__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_q5ivxg_k$(input, $completion);
      }
      *insert_vxhism_k$(input, $completion) {
        return yield* this.$$delegate_1__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_vxhism_k$(input instanceof TotpSecret() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_wzxw25_k$(input, $completion) {
        return yield* this.$$delegate_1__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_wzxw25_k$(input, $completion);
      }
      *modify_jvwj9y_k$(id, input, $completion) {
        return yield* this.$$delegate_1__1.modify_ntk3hh_k$(id, input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_jvwj9y_k$(id instanceof Uuid() ? id : THROW_CCE(), input, $completion);
      }
      *delete_zhxsae_k$(id, $completion) {
        yield* this.$$delegate_1__1.delete_xs5ou5_k$(id, $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_zhxsae_k$(id instanceof Uuid() ? id : THROW_CCE(), $completion);
      }
      *count_92jsbr_k$(input, $completion) {
        return yield* this.$$delegate_1__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_92jsbr_k$(input, $completion);
      }
      *groupCount_rm1qaf_k$(input, $completion) {
        return yield* this.$$delegate_1__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_rm1qaf_k$(input, $completion);
      }
      *aggregate_3mm0e_k$(input, $completion) {
        return yield* this.$$delegate_1__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_3mm0e_k$(input, $completion);
      }
      *groupAggregate_9tb7qi_k$(input, $completion) {
        return yield* this.$$delegate_1__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_9tb7qi_k$(input, $completion);
      }
      *permissions_2shruu_k$($completion) {
        return yield* this.$$delegate_1__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_2shruu_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveTimeBasedOTPProof', VOID, VOID, [TimeBasedOTP_0()], [1, 0, 2]);
    LiveTimeBasedOTPProofClass = $;
  }
  return LiveTimeBasedOTPProofClass;
}
var LivePasswordProofClass;
function LivePasswordProof() {
  if (LivePasswordProofClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.$this_1.fetcher_1, 'auth/proof/password/secrets', Companion_instance.serializer_9w0wvi_k$(), serializer(Companion_getInstance_0()));
        this.$$delegate_1__1 = new (Password())(this.$this_1.$this_1.fetcher_1, 'auth/proof/password');
      }
      *query_8ljy6s_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_8ljy6s_k$(input, $completion);
      }
      *insertBulk_5p6yxo_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_5p6yxo_k$(input, $completion);
      }
      *insert_r9vf1i_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_r9vf1i_k$(input instanceof PasswordSecret() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_d0vaxb_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_d0vaxb_k$(input, $completion);
      }
      *modify_v43k7q_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(id, input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_v43k7q_k$(id instanceof Uuid() ? id : THROW_CCE(), input, $completion);
      }
      *delete_zhxsae_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(id, $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_zhxsae_k$(id instanceof Uuid() ? id : THROW_CCE(), $completion);
      }
      *count_y6g31x_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_y6g31x_k$(input, $completion);
      }
      *groupCount_gbytir_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_gbytir_k$(input, $completion);
      }
      *aggregate_c1h6ye_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_c1h6ye_k$(input, $completion);
      }
      *groupAggregate_krmnqq_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_krmnqq_k$(input, $completion);
      }
      *permissions_90gew2_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_90gew2_k$($completion);
      }
      *provePasswordOwnership_n5u26d_k$(input, $completion) {
        return yield* this.$$delegate_1__1.provePasswordOwnership_n5u26d_k$(input, $completion);
      }
      get_via_18itzv_k$() {
        return this.$$delegate_1__1.get_via_18itzv_k$();
      }
      get_property_msvula_k$() {
        return this.$$delegate_1__1.get_property_msvula_k$();
      }
    }
    initMetadataForClass($, 'LivePasswordProof', VOID, VOID, [Password_0()], [0, 1, 2]);
    LivePasswordProofClass = $;
  }
  return LivePasswordProofClass;
}
var LiveSubscriptionsApiClass;
function LiveSubscriptionsApi() {
  if (LiveSubscriptionsApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpointsAndUpdatesWebSocket())(this.$this_1.$this_1.fetcher_1, 'notifications/subscriptions/rest', Companion_getInstance_1().serializer_rzxuna_k$(Companion_instance_0.serializer_9w0wvi_k$()), Companion_getInstance_5().serializer_rzxuna_k$(Companion_instance_0.serializer_9w0wvi_k$()));
      }
      *listEventSubscriptions_adwrwq_k$($completion) {
        return yield* this.$this_1.$this_1.fetcher_1.invoke_vgogw6_k$('notifications/subscriptions', Companion_getInstance_6().GET_1, serializer_0(Unit_instance), Unit_instance, ListSerializer(Companion_getInstance_2().serializer_rzxuna_k$(Companion_instance_0.serializer_9w0wvi_k$())), $completion);
      }
      *query_3alnho_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_3alnho_k$(input, $completion);
      }
      *insertBulk_fagi3o_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_fagi3o_k$(input, $completion);
      }
      *insert_l9kh2_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_l9kh2_k$(input instanceof NotificationSendMethods() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_82zc3z_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_82zc3z_k$(input, $completion);
      }
      *modify_qu1qih_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(id, input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_qu1qih_k$(id instanceof UserEventType() ? id : THROW_CCE(), input, $completion);
      }
      *delete_w0xpdz_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(id, $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_w0xpdz_k$(id instanceof UserEventType() ? id : THROW_CCE(), $completion);
      }
      *count_cgr6ut_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_cgr6ut_k$(input, $completion);
      }
      *groupCount_n0xgj7_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_n0xgj7_k$(input, $completion);
      }
      *aggregate_m3nuy_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_m3nuy_k$(input, $completion);
      }
      *groupAggregate_ayugr2_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_ayugr2_k$(input, $completion);
      }
      *permissions_2lhh7m_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_2lhh7m_k$($completion);
      }
      updates_3vknjq_k$() {
        return this.$$delegate_0__1.updates_3vknjq_k$();
      }
    }
    initMetadataForClass($, 'LiveSubscriptionsApi', VOID, VOID, [ClientModelRestUpdatesWebSocket()], [0, 1, 2]);
    LiveSubscriptionsApiClass = $;
  }
  return LiveSubscriptionsApiClass;
}
var LiveEventApiClass;
function LiveEventApi() {
  if (LiveEventApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
      }
    }
    initMetadataForClass($, 'LiveEventApi', VOID, VOID, VOID, [1]);
    LiveEventApiClass = $;
  }
  return LiveEventApiClass;
}
var LiveDynamicSettingsApiClass;
function LiveDynamicSettingsApi() {
  if (LiveDynamicSettingsApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'dynamicSettings', Companion_instance_4.serializer_9w0wvi_k$(), serializer_1(StringCompanionObject_instance));
      }
      *query_22eoii_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_22eoii_k$(input, $completion);
      }
      *insertBulk_nhpkua_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_nhpkua_k$(input, $completion);
      }
      *insert_lga34c_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_lga34c_k$(input instanceof DynamicSettings() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_xmllvq_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_xmllvq_k$(input, $completion);
      }
      *modify_l4fvas_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(id, input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_l4fvas_k$(typeof id === 'string' ? id : THROW_CCE(), input, $completion);
      }
      *delete_q32vk8_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(id, $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_q32vk8_k$(typeof id === 'string' ? id : THROW_CCE(), $completion);
      }
      *count_fuiz70_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_fuiz70_k$(input, $completion);
      }
      *groupCount_pib9o2_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_pib9o2_k$(input, $completion);
      }
      *aggregate_n54l4v_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_n54l4v_k$(input, $completion);
      }
      *groupAggregate_9oz6od_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_9oz6od_k$(input, $completion);
      }
      *permissions_dj4qjp_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_dj4qjp_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveDynamicSettingsApi', VOID, VOID, VOID, [0, 1, 2]);
    LiveDynamicSettingsApiClass = $;
  }
  return LiveDynamicSettingsApiClass;
}
var LiveUserAuthApiClass;
function LiveUserAuthApi() {
  if (LiveUserAuthApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'auth/session/sessions', Companion_getInstance_7().serializer_5gdsw7_k$(Companion_getInstance_3().serializer_9w0wvi_k$(), Companion_instance_0.serializer_9w0wvi_k$()), serializer(Companion_getInstance_0()));
        this.$$delegate_1__1 = new (LiveAuthClientEndpoints())(this.$this_1.fetcher_1, 'auth/session', Companion_getInstance_3().serializer_9w0wvi_k$(), Companion_instance_0.serializer_9w0wvi_k$());
        this.email_1 = new (LiveEmailApi())(this);
        this.totp_1 = new (LiveTimeBasedOTPProof())(this);
        this.password_1 = new (LivePasswordProof())(this);
        this.backupCode_1 = new (BackupCode())(this.$this_1.fetcher_1, 'auth/proof/backup-codes');
      }
      get_totp_wov340_k$() {
        return this.totp_1;
      }
      get_password_bodifw_k$() {
        return this.password_1;
      }
      *query_jj2g24_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_jj2g24_k$(input, $completion);
      }
      *insertBulk_1orol0_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_1orol0_k$(input, $completion);
      }
      *insert_mag6ta_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_mag6ta_k$(input instanceof Session() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_o204rj_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_o204rj_k$(input, $completion);
      }
      *modify_7bnkyq_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(id, input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_7bnkyq_k$(id instanceof Uuid() ? id : THROW_CCE(), input, $completion);
      }
      *delete_zhxsae_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(id, $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_zhxsae_k$(id instanceof Uuid() ? id : THROW_CCE(), $completion);
      }
      *count_u98rlx_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_u98rlx_k$(input, $completion);
      }
      *groupCount_cc5k39_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_cc5k39_k$(input, $completion);
      }
      *aggregate_vppt9k_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_vppt9k_k$(input, $completion);
      }
      *groupAggregate_bgz9e4_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_bgz9e4_k$(input, $completion);
      }
      *permissions_atgx90_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_atgx90_k$($completion);
      }
      *logInV2_olf4r6_k$(input, $completion) {
        return yield* this.$$delegate_1__1.logInV2_lw4xp7_k$(input, $completion);
      }
      logInV2_lw4xp7_k$(input, $completion) {
        return this.logInV2_olf4r6_k$(input, $completion);
      }
      *checkProofs_4kosok_k$(input, $completion) {
        return yield* this.$$delegate_1__1.checkProofs_qk2dxf_k$(input, $completion);
      }
      checkProofs_qk2dxf_k$(input, $completion) {
        return this.checkProofs_4kosok_k$(input, $completion);
      }
      *getTokenSimple_ybyi9u_k$(input, $completion) {
        return yield* this.$$delegate_1__1.getTokenSimple_ybyi9u_k$(input, $completion);
      }
      *getSelf_w13h6g_k$($completion) {
        return yield* this.$$delegate_1__1.getSelf_ivto1e_k$($completion);
      }
      getSelf_ivto1e_k$($completion) {
        return this.getSelf_w13h6g_k$($completion);
      }
      *terminateSession_ckz0qq_k$($completion) {
        yield* this.$$delegate_1__1.terminateSession_ckz0qq_k$($completion);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'LiveUserAuthApi', VOID, VOID, VOID, [0, 1, 2]);
    LiveUserAuthApiClass = $;
  }
  return LiveUserAuthApiClass;
}
var LiveFcmTokenApiClass;
function LiveFcmTokenApi() {
  if (LiveFcmTokenApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'fcmTokens', Companion_instance_1.serializer_9w0wvi_k$(), Companion_instance_2.serializer_9w0wvi_k$());
      }
      *registerToken_3z6r7r_k$(input, $completion) {
        return yield* this.$this_1.fetcher_1.invoke_vgogw6_k$('fcmTokens/register', Companion_getInstance_6().POST_1, Companion_instance_2.serializer_9w0wvi_k$(), new (ID())(input), Companion_getInstance_8().serializer_qelnde_k$(Companion_instance_1.serializer_9w0wvi_k$()), $completion);
      }
      *clearToken_xefvpg_k$(id, $completion) {
        return yield* this.$this_1.fetcher_1.invoke_vgogw6_k$('fcmTokens/' + this.$this_1.fetcher_1.url_tsvlb2_k$(new (ID())(id), Companion_instance_2.serializer_9w0wvi_k$()) + '/clear', Companion_getInstance_6().POST_1, serializer_0(Unit_instance), Unit_instance, serializer_2(BooleanCompanionObject_instance), $completion);
      }
      *query_jlu7fw_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_jlu7fw_k$(input, $completion);
      }
      *insertBulk_2xhows_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_2xhows_k$(input, $completion);
      }
      *insert_7l5bbu_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_7l5bbu_k$(input instanceof FcmToken() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_c5v44j_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_c5v44j_k$(input, $completion);
      }
      *modify_s7zy1w_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(new (ID())(id), input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_s7zy1w_k$(id instanceof ID() ? id.raw_1 : THROW_CCE(), input, $completion);
      }
      *delete_bmj530_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(new (ID())(id), $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_bmj530_k$(id instanceof ID() ? id.raw_1 : THROW_CCE(), $completion);
      }
      *count_2pwktz_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_2pwktz_k$(input, $completion);
      }
      *groupCount_q2nzpj_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_q2nzpj_k$(input, $completion);
      }
      *aggregate_xv3vxe_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_xv3vxe_k$(input, $completion);
      }
      *groupAggregate_xno5dy_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_xno5dy_k$(input, $completion);
      }
      *permissions_tdovp2_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_tdovp2_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveFcmTokenApi', VOID, VOID, VOID, [1, 0, 2]);
    LiveFcmTokenApiClass = $;
  }
  return LiveFcmTokenApiClass;
}
var LiveTCGNotificationsApiClass;
function LiveTCGNotificationsApi() {
  if (LiveTCGNotificationsApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpointsAndUpdatesWebSocket())(this.$this_1.fetcher_1, 'notifications/rest', Companion_getInstance_9().serializer_o2vhsn_k$(Companion_instance_0.serializer_9w0wvi_k$(), Companion_instance_5.serializer_9w0wvi_k$()), serializer(Companion_getInstance_0()));
        this.subscriptions_1 = new (LiveSubscriptionsApi())(this);
        this.events_1 = new (LiveEventApi())(this);
      }
      get_subscriptions_vnh9l9_k$() {
        return this.subscriptions_1;
      }
      *query_x7190s_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_x7190s_k$(input, $completion);
      }
      *insertBulk_ozcqn8_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_ozcqn8_k$(input, $completion);
      }
      *insert_vm3fiy_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_vm3fiy_k$(input instanceof Notification() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_3fftrp_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_3fftrp_k$(input, $completion);
      }
      *modify_5rq78q_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(id, input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_5rq78q_k$(id instanceof Uuid() ? id : THROW_CCE(), input, $completion);
      }
      *delete_zhxsae_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(id, $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_zhxsae_k$(id instanceof Uuid() ? id : THROW_CCE(), $completion);
      }
      *count_2mk7dn_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_2mk7dn_k$(input, $completion);
      }
      *groupCount_mghjxj_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_mghjxj_k$(input, $completion);
      }
      *aggregate_czol80_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_czol80_k$(input, $completion);
      }
      *groupAggregate_zdplk8_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_zdplk8_k$(input, $completion);
      }
      *permissions_s1wepk_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_s1wepk_k$($completion);
      }
      updates_3vknjq_k$() {
        return this.$$delegate_0__1.updates_3vknjq_k$();
      }
    }
    initMetadataForClass($, 'LiveTCGNotificationsApi', VOID, VOID, [ClientModelRestUpdatesWebSocket()], [0, 1, 2]);
    LiveTCGNotificationsApiClass = $;
  }
  return LiveTCGNotificationsApiClass;
}
var LiveFamilyApplicationApiClass;
function LiveFamilyApplicationApi() {
  if (LiveFamilyApplicationApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'familyApplications', Companion_getInstance_10().serializer_9w0wvi_k$(), Companion_instance_6.serializer_9w0wvi_k$());
      }
      *submitFamilyApplication_euzvcw_k$(input, $completion) {
        return yield* this.$this_1.fetcher_1.invoke_vgogw6_k$('familyApplications/submit', Companion_getInstance_6().POST_1, Companion_instance_7.serializer_9w0wvi_k$(), input, Companion_getInstance_10().serializer_9w0wvi_k$(), $completion);
      }
      *reviewFamilyApplication_y1gw00_k$(input, $completion) {
        return yield* this.$this_1.fetcher_1.invoke_vgogw6_k$('familyApplications/review', Companion_getInstance_6().POST_1, Companion_instance_8.serializer_9w0wvi_k$(), input, Companion_getInstance_10().serializer_9w0wvi_k$(), $completion);
      }
      *query_4dyhaq_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_4dyhaq_k$(input, $completion);
      }
      *insertBulk_rk3ouu_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_rk3ouu_k$(input, $completion);
      }
      *insert_ym0e74_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_ym0e74_k$(input instanceof FamilyApplication() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_6haoc0_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_6haoc0_k$(input, $completion);
      }
      *modify_h9hkqz_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(new (ID_0())(id), input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_h9hkqz_k$(id instanceof ID_0() ? id.raw_1 : THROW_CCE(), input, $completion);
      }
      *delete_6hzpln_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(new (ID_0())(id), $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_6hzpln_k$(id instanceof ID_0() ? id.raw_1 : THROW_CCE(), $completion);
      }
      *count_pkmxrq_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_pkmxrq_k$(input, $completion);
      }
      *groupCount_4llzek_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_4llzek_k$(input, $completion);
      }
      *aggregate_2felvb_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_2felvb_k$(input, $completion);
      }
      *groupAggregate_ba76f1_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_ba76f1_k$(input, $completion);
      }
      *permissions_v5qcrp_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_v5qcrp_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveFamilyApplicationApi', VOID, VOID, VOID, [1, 0, 2]);
    LiveFamilyApplicationApiClass = $;
  }
  return LiveFamilyApplicationApiClass;
}
var LiveProviderApplicationApiClass;
function LiveProviderApplicationApi() {
  if (LiveProviderApplicationApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'providerApplications', Companion_getInstance_11().serializer_9w0wvi_k$(), Companion_instance_9.serializer_9w0wvi_k$());
      }
      *submitProviderApplication_m4mzkd_k$(input, $completion) {
        return yield* this.$this_1.fetcher_1.invoke_vgogw6_k$('providerApplications/submit', Companion_getInstance_6().POST_1, Companion_instance_10.serializer_9w0wvi_k$(), input, Companion_getInstance_11().serializer_9w0wvi_k$(), $completion);
      }
      *reviewProviderApplication_fqhq7n_k$(input, $completion) {
        return yield* this.$this_1.fetcher_1.invoke_vgogw6_k$('providerApplications/review', Companion_getInstance_6().POST_1, Companion_instance_11.serializer_9w0wvi_k$(), input, Companion_getInstance_11().serializer_9w0wvi_k$(), $completion);
      }
      *query_ywpodo_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_ywpodo_k$(input, $completion);
      }
      *insertBulk_ybkud8_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_ybkud8_k$(input, $completion);
      }
      *insert_bg181m_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_bg181m_k$(input instanceof ProviderApplication() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_h9j6sd_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_h9j6sd_k$(input, $completion);
      }
      *modify_706tdo_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(new (ID_1())(id), input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_706tdo_k$(id instanceof ID_1() ? id.raw_1 : THROW_CCE(), input, $completion);
      }
      *delete_eekwb2_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(new (ID_1())(id), $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_eekwb2_k$(id instanceof ID_1() ? id.raw_1 : THROW_CCE(), $completion);
      }
      *count_tz039l_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_tz039l_k$(input, $completion);
      }
      *groupCount_xo05kh_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_xo05kh_k$(input, $completion);
      }
      *aggregate_wp42w4_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_wp42w4_k$(input, $completion);
      }
      *groupAggregate_vzg9gw_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_vzg9gw_k$(input, $completion);
      }
      *permissions_2vrwx4_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_2vrwx4_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveProviderApplicationApi', VOID, VOID, VOID, [1, 0, 2]);
    LiveProviderApplicationApiClass = $;
  }
  return LiveProviderApplicationApiClass;
}
var LiveChildPlacementApiClass;
function LiveChildPlacementApi() {
  if (LiveChildPlacementApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'childPlacements', Companion_getInstance_12().serializer_9w0wvi_k$(), Companion_instance_12.serializer_9w0wvi_k$());
      }
      *query_6cnyjw_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_6cnyjw_k$(input, $completion);
      }
      *insertBulk_n8zb50_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_n8zb50_k$(input, $completion);
      }
      *insert_govrdy_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_govrdy_k$(input instanceof ChildPlacement() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_axwxz7_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_axwxz7_k$(input, $completion);
      }
      *modify_wmzabg_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(new (ID_2())(id), input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_wmzabg_k$(id instanceof ID_2() ? id.raw_1 : THROW_CCE(), input, $completion);
      }
      *delete_opgj8c_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(new (ID_2())(id), $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_opgj8c_k$(id instanceof ID_2() ? id.raw_1 : THROW_CCE(), $completion);
      }
      *count_g3jcrt_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_g3jcrt_k$(input, $completion);
      }
      *groupCount_i992jd_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_i992jd_k$(input, $completion);
      }
      *aggregate_2uneyq_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_2uneyq_k$(input, $completion);
      }
      *groupAggregate_9xc7ty_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_9xc7ty_k$(input, $completion);
      }
      *permissions_6oci0a_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_6oci0a_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveChildPlacementApi', VOID, VOID, VOID, [1, 0, 2]);
    LiveChildPlacementApiClass = $;
  }
  return LiveChildPlacementApiClass;
}
var LiveChildAttendanceApiClass;
function LiveChildAttendanceApi() {
  if (LiveChildAttendanceApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'childAttendance', Companion_getInstance_13().serializer_9w0wvi_k$(), Companion_instance_13.serializer_9w0wvi_k$());
      }
      *query_b823s0_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_b823s0_k$(input, $completion);
      }
      *insertBulk_mujj2g_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_mujj2g_k$(input, $completion);
      }
      *insert_3bjm5q_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_3bjm5q_k$(input instanceof ChildAttendance() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_f6nx1z_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_f6nx1z_k$(input, $completion);
      }
      *modify_jce5zq_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(new (ID_3())(id), input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_jce5zq_k$(id instanceof ID_3() ? id.raw_1 : THROW_CCE(), input, $completion);
      }
      *delete_kxixws_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(new (ID_3())(id), $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_kxixws_k$(id instanceof ID_3() ? id.raw_1 : THROW_CCE(), $completion);
      }
      *count_wyqjqp_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_wyqjqp_k$(input, $completion);
      }
      *groupCount_xqyvyt_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_xqyvyt_k$(input, $completion);
      }
      *aggregate_qowcym_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_qowcym_k$(input, $completion);
      }
      *groupAggregate_z3klm2_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_z3klm2_k$(input, $completion);
      }
      *permissions_djajj2_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_djajj2_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveChildAttendanceApi', VOID, VOID, VOID, [0, 1, 2]);
    LiveChildAttendanceApiClass = $;
  }
  return LiveChildAttendanceApiClass;
}
var LiveCareLocationClosureApiClass;
function LiveCareLocationClosureApi() {
  if (LiveCareLocationClosureApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'careLocationClosures', Companion_getInstance_14().serializer_9w0wvi_k$(), Companion_instance_14.serializer_9w0wvi_k$());
      }
      *query_dgovls_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_dgovls_k$(input, $completion);
      }
      *insertBulk_3nvxm0_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_3nvxm0_k$(input, $completion);
      }
      *insert_8uv1u_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_8uv1u_k$(input instanceof CareLocationClosure() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_6vxyo7_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_6vxyo7_k$(input, $completion);
      }
      *modify_gjrtja_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(new (ID_4())(id), input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_gjrtja_k$(id instanceof ID_4() ? id.raw_1 : THROW_CCE(), input, $completion);
      }
      *delete_c2nra4_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(new (ID_4())(id), $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_c2nra4_k$(id instanceof ID_4() ? id.raw_1 : THROW_CCE(), $completion);
      }
      *count_uoiqld_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_uoiqld_k$(input, $completion);
      }
      *groupCount_qejhwb_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_qejhwb_k$(input, $completion);
      }
      *aggregate_m2hpki_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_m2hpki_k$(input, $completion);
      }
      *groupAggregate_c5p8nu_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_c5p8nu_k$(input, $completion);
      }
      *permissions_7nv976_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_7nv976_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveCareLocationClosureApi', VOID, VOID, VOID, [0, 1, 2]);
    LiveCareLocationClosureApiClass = $;
  }
  return LiveCareLocationClosureApiClass;
}
var LiveLocationAttendancePeriodApiClass;
function LiveLocationAttendancePeriodApi() {
  if (LiveLocationAttendancePeriodApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'locationAttendancePeriods', Companion_instance_15.serializer_9w0wvi_k$(), Companion_instance_16.serializer_9w0wvi_k$());
      }
      *query_bij7ro_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_bij7ro_k$(input, $completion);
      }
      *insertBulk_9vuak_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_9vuak_k$(input, $completion);
      }
      *insert_81m7ja_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_81m7ja_k$(input instanceof LocationAttendancePeriod() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_vg987h_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_vg987h_k$(input, $completion);
      }
      *modify_27ghmu_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(new (ID_5())(id), input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_27ghmu_k$(id instanceof ID_5() ? id.raw_1 : THROW_CCE(), input, $completion);
      }
      *delete_gb2y5i_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(new (ID_5())(id), $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_gb2y5i_k$(id instanceof ID_5() ? id.raw_1 : THROW_CCE(), $completion);
      }
      *count_bt93n7_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_bt93n7_k$(input, $completion);
      }
      *groupCount_rtv74f_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_rtv74f_k$(input, $completion);
      }
      *aggregate_374gy0_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_374gy0_k$(input, $completion);
      }
      *groupAggregate_i2p3w0_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_i2p3w0_k$(input, $completion);
      }
      *permissions_8zr0v4_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_8zr0v4_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveLocationAttendancePeriodApi', VOID, VOID, VOID, [0, 1, 2]);
    LiveLocationAttendancePeriodApiClass = $;
  }
  return LiveLocationAttendancePeriodApiClass;
}
var LiveCareLocationApiClass;
function LiveCareLocationApi() {
  if (LiveCareLocationApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'careLocations', Companion_getInstance_15().serializer_9w0wvi_k$(), Companion_instance_17.serializer_9w0wvi_k$());
      }
      *query_w38amk_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_w38amk_k$(input, $completion);
      }
      *insertBulk_pb05to_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_pb05to_k$(input, $completion);
      }
      *insert_xgya7u_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_xgya7u_k$(input instanceof CareLocation() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_txx8cm_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_txx8cm_k$(input, $completion);
      }
      *modify_ag476p_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(new (ID_6())(id), input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_ag476p_k$(id instanceof ID_6() ? id.raw_1 : THROW_CCE(), input, $completion);
      }
      *delete_iku1z5_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(new (ID_6())(id), $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_iku1z5_k$(id instanceof ID_6() ? id.raw_1 : THROW_CCE(), $completion);
      }
      *count_f0m7os_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_f0m7os_k$(input, $completion);
      }
      *groupCount_9g8wfe_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_9g8wfe_k$(input, $completion);
      }
      *aggregate_bij9c1_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_bij9c1_k$(input, $completion);
      }
      *groupAggregate_njwujb_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_njwujb_k$(input, $completion);
      }
      *permissions_2em7d3_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_2em7d3_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveCareLocationApi', VOID, VOID, VOID, [0, 1, 2]);
    LiveCareLocationApiClass = $;
  }
  return LiveCareLocationApiClass;
}
var LiveCareLocationProgramsApiClass;
function LiveCareLocationProgramsApi() {
  if (LiveCareLocationProgramsApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'CareLocationPrograms', Companion_getInstance_18().serializer_9w0wvi_k$(), Companion_instance_28.serializer_9w0wvi_k$());
      }
      *query_2lbxim_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_2lbxim_k$(input, $completion);
      }
      *insertBulk_5w4fgm_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_5w4fgm_k$(input, $completion);
      }
      *insert_d1bq6c_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_d1bq6c_k$(input instanceof CareLocationProgram() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_3jvkn6_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_3jvkn6_k$(input, $completion);
      }
      *modify_tw2zq7_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(new (ID_8())(id), input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_tw2zq7_k$(id instanceof ID_8() ? id.raw_1 : THROW_CCE(), input, $completion);
      }
      *delete_lpyh6b_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(new (ID_8())(id), $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_lpyh6b_k$(id instanceof ID_8() ? id.raw_1 : THROW_CCE(), $completion);
      }
      *count_k8p7a0_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_k8p7a0_k$(input, $completion);
      }
      *groupCount_z55tym_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_z55tym_k$(input, $completion);
      }
      *aggregate_fxz3d1_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_fxz3d1_k$(input, $completion);
      }
      *groupAggregate_mb217z_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_mb217z_k$(input, $completion);
      }
      *permissions_pe5bxl_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_pe5bxl_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveCareLocationProgramsApi', VOID, VOID, VOID, [0, 1, 2]);
    LiveCareLocationProgramsApiClass = $;
  }
  return LiveCareLocationProgramsApiClass;
}
var LiveCareLocationProgramDatedApiClass;
function LiveCareLocationProgramDatedApi() {
  if (LiveCareLocationProgramDatedApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'CareLocationProgramDated', Companion_instance_29.serializer_9w0wvi_k$(), Companion_instance_30.serializer_9w0wvi_k$());
      }
      *query_d10sy4_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_d10sy4_k$(input, $completion);
      }
      *insertBulk_onz324_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_onz324_k$(input, $completion);
      }
      *insert_b9kj5m_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_b9kj5m_k$(input instanceof CareLocationProgramDated() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_canfcc_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_canfcc_k$(input, $completion);
      }
      *modify_6pxaxf_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(new (ID_9())(id), input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_6pxaxf_k$(id instanceof ID_9() ? id.raw_1 : THROW_CCE(), input, $completion);
      }
      *delete_6323ar_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(new (ID_9())(id), $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_6323ar_k$(id instanceof ID_9() ? id.raw_1 : THROW_CCE(), $completion);
      }
      *count_vxnjwm_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_vxnjwm_k$(input, $completion);
      }
      *groupCount_ltssp4_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_ltssp4_k$(input, $completion);
      }
      *aggregate_czp6of_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_czp6of_k$(input, $completion);
      }
      *groupAggregate_t1b3lj_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_t1b3lj_k$(input, $completion);
      }
      *permissions_jpbj7d_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_jpbj7d_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveCareLocationProgramDatedApi', VOID, VOID, VOID, [0, 1, 2]);
    LiveCareLocationProgramDatedApiClass = $;
  }
  return LiveCareLocationProgramDatedApiClass;
}
var LiveCareProviderRemittanceApiClass;
function LiveCareProviderRemittanceApi() {
  if (LiveCareProviderRemittanceApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'careProviderRemittances', Companion_getInstance_20().serializer_9w0wvi_k$(), Companion_instance_34.serializer_9w0wvi_k$());
      }
      *previewRemittance_ywbd9v_k$(input, $completion) {
        return yield* this.$this_1.fetcher_1.invoke_vgogw6_k$('careProviderRemittances/preview', Companion_getInstance_6().POST_1, Companion_instance_35.serializer_9w0wvi_k$(), input, Companion_getInstance_21().serializer_9w0wvi_k$(), $completion);
      }
      *issueRemittance_eyg3pc_k$(input, $completion) {
        return yield* this.$this_1.fetcher_1.invoke_vgogw6_k$('careProviderRemittances/issue', Companion_getInstance_6().POST_1, Companion_instance_35.serializer_9w0wvi_k$(), input, Companion_getInstance_20().serializer_9w0wvi_k$(), $completion);
      }
      *query_slnyrw_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_slnyrw_k$(input, $completion);
      }
      *insertBulk_ntdp8c_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_ntdp8c_k$(input, $completion);
      }
      *insert_ww90p2_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_ww90p2_k$(input instanceof CareProviderRemittance() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_bv8ryk_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_bv8ryk_k$(input, $completion);
      }
      *modify_15dun9_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(new (ID_10())(id), input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_15dun9_k$(id instanceof ID_10() ? id.raw_1 : THROW_CCE(), input, $completion);
      }
      *delete_jc9irp_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(new (ID_10())(id), $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_jc9irp_k$(id instanceof ID_10() ? id.raw_1 : THROW_CCE(), $completion);
      }
      *count_z8h6a6_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_z8h6a6_k$(input, $completion);
      }
      *groupCount_dygh4g_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_dygh4g_k$(input, $completion);
      }
      *aggregate_qmjdrt_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_qmjdrt_k$(input, $completion);
      }
      *groupAggregate_d71fxr_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_d71fxr_k$(input, $completion);
      }
      *permissions_2jky69_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_2jky69_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveCareProviderRemittanceApi', VOID, VOID, VOID, [1, 0, 2]);
    LiveCareProviderRemittanceApiClass = $;
  }
  return LiveCareProviderRemittanceApiClass;
}
var LiveSingleChildDayApiClass;
function LiveSingleChildDayApi() {
  if (LiveSingleChildDayApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(this.$this_1.fetcher_1, 'singleChildDays', Companion_getInstance_22().serializer_9w0wvi_k$(), Companion_instance_36.serializer_9w0wvi_k$());
      }
      *totalsByPlacement_39jjrf_k$(input, $completion) {
        return yield* this.$this_1.fetcher_1.invoke_vgogw6_k$('singleChildDays/totals-by-placement', Companion_getInstance_6().POST_1, Companion_instance_41.serializer_qelnde_k$(Companion_getInstance_22().serializer_9w0wvi_k$()), input, MapSerializer(serializer_1(StringCompanionObject_instance), Companion_getInstance_23().serializer_9w0wvi_k$()), $completion);
      }
      *query_2iomri_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      query_o986pg_k$(input, $completion) {
        return this.query_2iomri_k$(input, $completion);
      }
      *insertBulk_dcgj6e_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      insertBulk_vz3d8k_k$(input, $completion) {
        return this.insertBulk_dcgj6e_k$(input, $completion);
      }
      *insert_eu2bkc_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      insert_a1u7p6_k$(input, $completion) {
        return this.insert_eu2bkc_k$(input instanceof SingleChildDay() ? input : THROW_CCE(), $completion);
      }
      *bulkModify_vc5a9m_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      bulkModify_ugvnv2_k$(input, $completion) {
        return this.bulkModify_vc5a9m_k$(input, $completion);
      }
      *modify_a0ozrd_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(new (ID_11())(id), input, $completion);
      }
      modify_ntk3hh_k$(id, input, $completion) {
        return this.modify_a0ozrd_k$(id instanceof ID_11() ? id.raw_1 : THROW_CCE(), input, $completion);
      }
      *delete_7q6xob_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(new (ID_11())(id), $completion);
        return Unit_instance;
      }
      delete_xs5ou5_k$(id, $completion) {
        return this.delete_7q6xob_k$(id instanceof ID_11() ? id.raw_1 : THROW_CCE(), $completion);
      }
      *count_j9nvkw_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      count_q0vep4_k$(input, $completion) {
        return this.count_j9nvkw_k$(input, $completion);
      }
      *groupCount_ap5o2i_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      groupCount_z3zpjq_k$(input, $completion) {
        return this.groupCount_ap5o2i_k$(input, $completion);
      }
      *aggregate_cj4r4d_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      aggregate_x3h2lp_k$(input, $completion) {
        return this.aggregate_cj4r4d_k$(input, $completion);
      }
      *groupAggregate_th2au1_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      groupAggregate_efln9_k$(input, $completion) {
        return this.groupAggregate_th2au1_k$(input, $completion);
      }
      *permissions_7c8767_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      permissions_x4pqz_k$($completion) {
        return this.permissions_7c8767_k$($completion);
      }
    }
    initMetadataForClass($, 'LiveSingleChildDayApi', VOID, VOID, VOID, [1, 0, 2]);
    LiveSingleChildDayApiClass = $;
  }
  return LiveSingleChildDayApiClass;
}
var LiveAnonymousSurveyApiClass;
function LiveAnonymousSurveyApi() {
  if (LiveAnonymousSurveyApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
      }
      *getAnonymousSurvey_3d3sl6_k$(survey, employer, $completion) {
        return yield* this.$this_1.fetcher_1.invoke_vgogw6_k$('anonymous-surveys/' + this.$this_1.fetcher_1.url_tsvlb2_k$(new (ID_12())(survey), Companion_instance_42.serializer_9w0wvi_k$()) + '/' + this.$this_1.fetcher_1.url_tsvlb2_k$(new (ID_7())(employer), Companion_instance_18.serializer_9w0wvi_k$()), Companion_getInstance_6().GET_1, serializer_0(Unit_instance), Unit_instance, Companion_instance_43.serializer_9w0wvi_k$(), $completion);
      }
      *answerAnonymousSurvey_8qah3o_k$(survey, employer, input, $completion) {
        return yield* this.$this_1.fetcher_1.invoke_vgogw6_k$('anonymous-surveys/' + this.$this_1.fetcher_1.url_tsvlb2_k$(new (ID_12())(survey), Companion_instance_42.serializer_9w0wvi_k$()) + '/' + this.$this_1.fetcher_1.url_tsvlb2_k$(new (ID_7())(employer), Companion_instance_18.serializer_9w0wvi_k$()) + '/answer', Companion_getInstance_6().POST_1, Companion_getInstance_24().serializer_9w0wvi_k$(), input, ListSerializer(Companion_getInstance_25().serializer_9w0wvi_k$()), $completion);
      }
      *startAnonymousTaking_ouul51_k$(survey, employer, input, $completion) {
        return yield* this.$this_1.fetcher_1.invoke_vgogw6_k$('anonymous-surveys/' + this.$this_1.fetcher_1.url_tsvlb2_k$(new (ID_12())(survey), Companion_instance_42.serializer_9w0wvi_k$()) + '/' + this.$this_1.fetcher_1.url_tsvlb2_k$(new (ID_7())(employer), Companion_instance_18.serializer_9w0wvi_k$()) + '/start', Companion_getInstance_6().POST_1, Companion_getInstance_26().serializer_9w0wvi_k$(), input, Companion_getInstance_27().serializer_9w0wvi_k$(), $completion);
      }
      *getAnonymousTaking_kg5uas_k$(survey, employer, input, $completion) {
        return yield* this.$this_1.fetcher_1.invoke_vgogw6_k$('anonymous-surveys/' + this.$this_1.fetcher_1.url_tsvlb2_k$(new (ID_12())(survey), Companion_instance_42.serializer_9w0wvi_k$()) + '/' + this.$this_1.fetcher_1.url_tsvlb2_k$(new (ID_7())(employer), Companion_instance_18.serializer_9w0wvi_k$()) + '/taking', Companion_getInstance_6().POST_1, serializer(Companion_getInstance_0()), input, Companion_getInstance_28().serializer_9w0wvi_k$(), $completion);
      }
    }
    initMetadataForClass($, 'LiveAnonymousSurveyApi', VOID, VOID, VOID, [2, 3]);
    LiveAnonymousSurveyApiClass = $;
  }
  return LiveAnonymousSurveyApiClass;
}
var LiveMetaApiClass;
function LiveMetaApi() {
  if (LiveMetaApiClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
      }
    }
    initMetadataForClass($, 'LiveMetaApi', VOID, VOID, VOID, [0, 1]);
    LiveMetaApiClass = $;
  }
  return LiveMetaApiClass;
}
var LiveApiClass;
function LiveApi() {
  if (LiveApiClass === VOID) {
    class $ {
      constructor(fetcher) {
        this.fetcher_1 = fetcher;
        this.uploadEarlyEndpoint_1 = new (LiveClientUploadEarlyEndpoints())(this.fetcher_1, 'upload-early');
        this.appRelease_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'app-releases', Companion_getInstance_4().serializer_9w0wvi_k$(), Companion_instance_3.serializer_9w0wvi_k$());
        this.dynamicSettings_1 = new (LiveDynamicSettingsApi())(this);
        this.user_1 = new (LiveClientModelRestEndpointsAndUpdatesWebSocket())(this.fetcher_1, 'users/rest', Companion_getInstance_3().serializer_9w0wvi_k$(), Companion_instance_0.serializer_9w0wvi_k$());
        this.userAuth_1 = new (LiveUserAuthApi())(this);
        this.fcmToken_1 = new (LiveFcmTokenApi())(this);
        this.tCGNotifications_1 = new (LiveTCGNotificationsApi())(this);
        this.family_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'families', Companion_getInstance_16().serializer_9w0wvi_k$(), Companion_instance_19.serializer_9w0wvi_k$());
        this.familyEmployerAuthorization_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'familyEmployerAuthorizations', Companion_instance_20.serializer_9w0wvi_k$(), Companion_instance_21.serializer_9w0wvi_k$());
        this.familyApplication_1 = new (LiveFamilyApplicationApi())(this);
        this.providerApplication_1 = new (LiveProviderApplicationApi())(this);
        this.child_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'children', Companion_getInstance_17().serializer_9w0wvi_k$(), Companion_instance_22.serializer_9w0wvi_k$());
        this.childPlacement_1 = new (LiveChildPlacementApi())(this);
        this.childAttendance_1 = new (LiveChildAttendanceApi())(this);
        this.careLocationClosure_1 = new (LiveCareLocationClosureApi())(this);
        this.locationAttendancePeriod_1 = new (LiveLocationAttendancePeriodApi())(this);
        this.careProvider_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'careProviders', Companion_instance_23.serializer_9w0wvi_k$(), Companion_instance_24.serializer_9w0wvi_k$());
        this.careLocation_1 = new (LiveCareLocationApi())(this);
        this.employer_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'employers', Companion_instance_25.serializer_9w0wvi_k$(), Companion_instance_18.serializer_9w0wvi_k$());
        this.grant_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'grants', Companion_instance_26.serializer_9w0wvi_k$(), Companion_instance_27.serializer_9w0wvi_k$());
        this.careLocationPrograms_1 = new (LiveCareLocationProgramsApi())(this);
        this.careLocationProgramDated_1 = new (LiveCareLocationProgramDatedApi())(this);
        this.careProgramTemplate_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'CareProgramTemplates', Companion_getInstance_19().serializer_9w0wvi_k$(), Companion_instance_31.serializer_9w0wvi_k$());
        this.careProgramTemplateDated_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'CareProgramTemplateDated', Companion_instance_32.serializer_9w0wvi_k$(), Companion_instance_33.serializer_9w0wvi_k$());
        this.employerRates_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'employerRates', Companion_getInstance_30().serializer_9w0wvi_k$(), Companion_instance_46.serializer_9w0wvi_k$());
        this.grantRates_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'grantRates', Companion_getInstance_31().serializer_9w0wvi_k$(), Companion_instance_47.serializer_9w0wvi_k$());
        this.grantAccountTransaction_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'grantAccountTransactions', Companion_instance_37.serializer_9w0wvi_k$(), Companion_instance_38.serializer_9w0wvi_k$());
        this.employerAccountTransaction_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'employerAccountTransactions', Companion_instance_39.serializer_9w0wvi_k$(), Companion_instance_40.serializer_9w0wvi_k$());
        this.employerMonthAggregates_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'employerMonthAggregates', Companion_getInstance_32().serializer_9w0wvi_k$(), Companion_instance_48.serializer_9w0wvi_k$());
        this.careProviderRemittance_1 = new (LiveCareProviderRemittanceApi())(this);
        this.singleChildDay_1 = new (LiveSingleChildDayApi())(this);
        this.survey_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'surveys', Companion_getInstance_29().serializer_9w0wvi_k$(), Companion_instance_42.serializer_9w0wvi_k$());
        this.questionResponse_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'questionResponses', Companion_getInstance_25().serializer_9w0wvi_k$(), Companion_instance_44.serializer_9w0wvi_k$());
        this.surveyProgress_1 = new (LiveClientModelRestEndpoints())(this.fetcher_1, 'surveyProgress', Companion_getInstance_27().serializer_9w0wvi_k$(), Companion_instance_45.serializer_9w0wvi_k$());
        this.anonymousSurvey_1 = new (LiveAnonymousSurveyApi())(this);
        this.meta_1 = new (LiveMetaApi())(this);
      }
      withHeaderCalculator_vab9hb_k$(calculator) {
        return new (LiveApi())(this.fetcher_1.withHeaderCalculator_vab9hb_k$(calculator));
      }
      *resetSeedData_s2kgq5_k$($completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$('debug/reset-seed-data', Companion_getInstance_6().POST_1, serializer_0(Unit_instance), Unit_instance, serializer_0(Unit_instance), $completion);
      }
      get_appRelease_glbnzj_k$() {
        return this.appRelease_1;
      }
      get_dynamicSettings_6ukhax_k$() {
        return this.dynamicSettings_1;
      }
      get_user_wovspg_k$() {
        return this.user_1;
      }
      get_userAuth_yt6u3g_k$() {
        return this.userAuth_1;
      }
      get_fcmToken_a95zde_k$() {
        return this.fcmToken_1;
      }
      get_tCGNotifications_dv414p_k$() {
        return this.tCGNotifications_1;
      }
      get_family_d7lffx_k$() {
        return this.family_1;
      }
      get_familyEmployerAuthorization_hehyj5_k$() {
        return this.familyEmployerAuthorization_1;
      }
      get_familyApplication_7vdin7_k$() {
        return this.familyApplication_1;
      }
      get_providerApplication_tefbxy_k$() {
        return this.providerApplication_1;
      }
      get_child_ipppmb_k$() {
        return this.child_1;
      }
      get_childPlacement_o77pq_k$() {
        return this.childPlacement_1;
      }
      get_childAttendance_eqcv24_k$() {
        return this.childAttendance_1;
      }
      get_careLocationClosure_wog2z0_k$() {
        return this.careLocationClosure_1;
      }
      get_locationAttendancePeriod_ojr4ns_k$() {
        return this.locationAttendancePeriod_1;
      }
      get_careProvider_y0cmmt_k$() {
        return this.careProvider_1;
      }
      get_careLocation_drerzj_k$() {
        return this.careLocation_1;
      }
      get_employer_c2djlo_k$() {
        return this.employer_1;
      }
      get_grant_is33zn_k$() {
        return this.grant_1;
      }
      get_careLocationPrograms_g0oima_k$() {
        return this.careLocationPrograms_1;
      }
      get_careLocationProgramDated_cjifxd_k$() {
        return this.careLocationProgramDated_1;
      }
      get_careProgramTemplate_sacmzo_k$() {
        return this.careProgramTemplate_1;
      }
      get_careProgramTemplateDated_lad5ki_k$() {
        return this.careProgramTemplateDated_1;
      }
      get_employerRates_stalch_k$() {
        return this.employerRates_1;
      }
      get_grantRates_6bprq8_k$() {
        return this.grantRates_1;
      }
      get_grantAccountTransaction_b8gjzw_k$() {
        return this.grantAccountTransaction_1;
      }
      get_employerAccountTransaction_bpegb9_k$() {
        return this.employerAccountTransaction_1;
      }
      get_employerMonthAggregates_z5j4ls_k$() {
        return this.employerMonthAggregates_1;
      }
      get_careProviderRemittance_7bo3o7_k$() {
        return this.careProviderRemittance_1;
      }
      get_singleChildDay_52scz3_k$() {
        return this.singleChildDay_1;
      }
      get_survey_jo9uub_k$() {
        return this.survey_1;
      }
      get_questionResponse_p55ixc_k$() {
        return this.questionResponse_1;
      }
      get_surveyProgress_gv29io_k$() {
        return this.surveyProgress_1;
      }
      get_anonymousSurvey_8r5uiq_k$() {
        return this.anonymousSurvey_1;
      }
    }
    initMetadataForClass($, 'LiveApi', VOID, VOID, VOID, [0]);
    LiveApiClass = $;
  }
  return LiveApiClass;
}
//region block: exports
export {
  LiveApi as LiveApij3dypzwiy6xu,
};
//endregion

//# sourceMappingURL=LiveApi.mjs.map
